'use client';

import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import { usePathname } from 'next/navigation';

import LoaderOverlay from '@/components/common/LoaderOverlay/LoaderOverlay';
import { useStores } from '@/hooks';

/**
 * A simple loader implementation displaying `LoaderOverlay` on manual "loading" state trigger. May be used e.g.
 * to display overlay loader on page navigation (for example, via `router.push`). To display loader
 * `appStore.setLoading()` should be invoked. Loader is reset on every page navigation, see effect below. When
 * pathname changes, effect is invoked and loading state is reset.
 */
const Loader: React.FC = () => {
  const pathname = usePathname();
  const { appStore } = useStores();

  useEffect(() => {
    appStore.setLoading(false);
  }, [pathname]);

  if (!appStore.loading) {
    return null;
  }

  return <LoaderOverlay />;
};

export default observer(Loader);
